import { render, staticRenderFns } from "./ContactTypeForm.vue?vue&type=template&id=5a5aeb03&scoped=true&"
import script from "./ContactTypeForm.vue?vue&type=script&lang=js&"
export * from "./ContactTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5aeb03",
  null
  
)

export default component.exports